import { MenuItem } from "@chakra-ui/react";
import { UseQueryResult } from "@tanstack/react-query";
import { useRouter } from "@uirouter/react";
import { getFullName } from "../../../../../shared/utils/get-full-name";
import { phoneFormatter } from "../../../../../shared/utils/phone-formatter";
import { usePhoneNumberDialerPopup } from "../../../../call-center/hooks/usePhoneNumberDialerPopup";
import { useCommCenterTicketPopup } from "../../../../communication/hooks/useCommCenterTicketPopup";
import { VisitAssignmentEntityCard } from "./VisitAssignmentEntityCard";
import { VisitAssignmentEntityCardSkeleton } from "./VisitAssignmentEntityCardSkeleton";
import { AssignmentRecord } from "../assignments.utils";
import { VisitAssigmentEntityCardError } from "./VisitAssigmentEntityCardError";

export function VisitAssignmentCaregiverCard(props: { query: UseQueryResult<AssignmentRecord> }) {
  const ticketPopup = useCommCenterTicketPopup();
  const dialerPopup = usePhoneNumberDialerPopup();
  const { stateService } = useRouter();

  switch (props.query.status) {
    case "pending":
      return <VisitAssignmentEntityCardSkeleton />;
    case "error":
      return <VisitAssigmentEntityCardError />;
    case "success": {
      if (props.query.data.caregiver === null) return <></>;

      const { displayId, id, phoneNumbers, avatarUrl } = props.query.data.caregiver;
      return (
        <VisitAssignmentEntityCard
          description={`CAREGIVER #${displayId ?? id}`}
          name={getFullName(props.query.data.caregiver)}
          src={avatarUrl ?? undefined}
          onClick={() => stateService.go("app.visitAssignments.assignment", { caregiver: id })}
          onClickChat={() => {
            ticketPopup.open({
              primaryEntity: "Caregiver",
              caregiverId: id,
            });
          }}
        >
          <>
            {phoneNumbers.nodes.map(({ phoneNumber }) => (
              <MenuItem
                key={phoneNumber}
                onClick={() => dialerPopup.open({ predefinedPhoneNumber: phoneNumber })}
              >
                {phoneFormatter.formatNationalIfValid(phoneNumber)}
              </MenuItem>
            ))}
          </>
        </VisitAssignmentEntityCard>
      );
    }
  }
}
